'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refineDimensions = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var refineDimensions = exports.refineDimensions = function refineDimensions() {
  var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dataquery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var selectionIds = R.pipe(R.split('.'), R.map(R.split('+')))(dataquery);

  return R.addIndex(R.map)(function (dim, index) {
    var selection = R.nth(index, selectionIds);
    var values = R.map(function (val) {
      if (R.includes(val.id, selection || []) || R.isNil(selection) || R.length(selection) === 0 || R.isEmpty(R.head(selection))) {
        return R.assoc('isSelected', true, val);
      }
      return R.assoc('empty', true, val);
    }, dim.values || []);

    var size = R.length(values);
    return (0, _extends3.default)({}, dim, { values: values, header: size === 1 || size > 1 && R.length(selection) === 1 && !R.isEmpty(R.head(selection)) });
  }, dimensions);
};